import { mkType, SchemaToType } from '@main/schema-utils';

export const ClassificationConfidence = mkType({
  name: 'ClassificationConfidence',
  comment: 'The percent of guesses in the categories high, medium,and low',
  fields: {
    high: {
      comment: 'The percent of guesses in the high category',
      type: 'int',
    },
    medium: {
      comment: 'The percent of guesses in the medium category',
      type: 'int',
    },
    low: {
      comment: 'The percent of guesses in the low category',
      type: 'int',
    },
  },
});

/** Override type */
export type ClassificationConfidence = SchemaToType<
  typeof ClassificationConfidence
>;

export const SiloClassificationConfidenceSummary = mkType({
  name: 'SiloClassificationConfidenceSummary',
  comment: 'Summary of classification guess confidence',
  fields: {
    dataSiloId: {
      comment: 'The data silo that this confidence summary refers to',
      type: 'id',
      modelName: 'dataSilo',
    },
    confidence: {
      comment:
        'The percent of guesses for each category of high, medium, and low',
      type: ClassificationConfidence,
    },
    total: {
      comment: 'The total number of guesses included in the counts',
      type: 'int',
    },
  },
});

/** Override type */
export type SiloClassificationConfidenceSummary = SchemaToType<
  typeof SiloClassificationConfidenceSummary
>;
